/**
 * Vishram — age gate
 *
 * Fail-safe direction: this module binds the unlock handler BEFORE it does
 * anything else that could throw. A previous version set overflow:hidden and
 * then did work that could throw, leaving visitors locked on a frozen page.
 * If later steps in this file fail, the visitor can still tap "I am of age"
 * and get into the site.
 *
 * The whole module is wrapped in try/catch — a failure here must never take
 * down the rest of the page (live clock, cart gate, etc.), and this file
 * must never take those down either.
 */
(function () {
  'use strict';

  if (window.__vishramAgeGateInit) {
    return;
  }
  window.__vishramAgeGateInit = true;

  try {
    var root = document.getElementById('vishram-age-gate');
    if (!root) {
      return;
    }

    var unlockBtn = root.querySelector('[data-age-gate-unlock]');
    var leaveBtn = root.querySelector('[data-age-gate-leave]');
    var minimumAge = 18;

    var memoryStore = {};
    var storage = {
      get: function (key) {
        try {
          return window.localStorage.getItem(key);
        } catch (e) {
          return Object.prototype.hasOwnProperty.call(memoryStore, key)
            ? memoryStore[key]
            : null;
        }
      },
      set: function (key, value) {
        try {
          window.localStorage.setItem(key, value);
        } catch (e) {
          memoryStore[key] = value;
        }
      }
    };

    function unlock() {
      try {
        storage.set('vishram_age_confirmed', '1');
      } catch (e) {
      }
      root.setAttribute('hidden', 'hidden');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('vishram-age-gate-open');
      releaseFocusTrap();
      if (lastFocusedEl && lastFocusedEl.focus) {
        lastFocusedEl.focus();
      }
    }

    function leave() {
      window.location.href = 'https://www.google.com';
    }

    if (unlockBtn) {
      unlockBtn.addEventListener('click', unlock);
    }
    if (leaveBtn) {
      leaveBtn.addEventListener('click', leave);
    }

    var configEl = document.getElementById('vishram-config');
    if (configEl) {
      try {
        var config = JSON.parse(configEl.textContent);
        if (config && typeof config.ageGateMinimumAge === 'number') {
          minimumAge = config.ageGateMinimumAge;
        }
      } catch (e) {
      }
    }
    var ageLabel = root.querySelector('[data-age-gate-minimum]');
    if (ageLabel) {
      ageLabel.textContent = String(minimumAge);
    }

    if (storage.get('vishram_age_confirmed') === '1') {
      root.setAttribute('hidden', 'hidden');
      root.setAttribute('aria-hidden', 'true');
      return;
    }

    var lastFocusedEl = document.activeElement;
    root.removeAttribute('hidden');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('vishram-age-gate-open');

    var focusableSelector =
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';
    var focusableNodeList = root.querySelectorAll(focusableSelector);
    var focusable = Array.prototype.slice.call(focusableNodeList);

    if (focusable.length > 0) {
      focusable[0].focus();
    }

    function trapKeydown(e) {
      if (e.key !== 'Tab' && e.keyCode !== 9) {
        if (e.key === 'Escape' || e.keyCode === 27) {
        }
        return;
      }
      if (focusable.length === 0) {
        e.preventDefault();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    root.addEventListener('keydown', trapKeydown);

    function releaseFocusTrap() {
      try {
        root.removeEventListener('keydown', trapKeydown);
      } catch (e) {
      }
    }
  } catch (err) {
    if (window.console && window.console.error) {
      window.console.error('vishram age-gate error', err);
    }
  }
})();
